// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
export const PRACTICE = 1
export const TEST_OR_QUIZ = 2
